<template>
    <div class="service m-b-20">
      <p class="brder-b title">我的服务</p>
      <ul class="serviceUl flex-row-wrap">
        <li class="item" v-for="(item, index) in list" :key="index" @click="viewPage(item.type)">
            <img :src="item.img" alt="">
            <p>{{item.name}}</p>
        </li>
      </ul>
    </div>
</template>
<script>
import contract from '@/assets/img/合同@3x.png';
import appointment from '@/assets/img/leijiyuyue@3x.png';
import budget from '@/assets/img/yusuan@3x.png';
import news from '@/assets/img/xiaoxi-2@3x.png';
import problem from '@/assets/img/ICon--2@3x.png';
import follow from '@/assets/img/guanzhu-3@3x.png';
export default {
    data(){
        return {
            contract,
            appointment,
            budget,
            news,
            problem,
            follow,
            list:[
                {name:'我的合同', img:contract , type: 2},
                {name:'我的预约', img:appointment, type:3},
                {name:'我的预算', img:budget, type: 1},
                {name:'我的消息', img:news},
            ]
        }
    },
    methods:{
      viewPage(type){
        if(type == 1){
          this.$router.push({path:'/budget'});
        } else if (type == 2) {
          this.$router.push({path:'/myList'});
        } else if (type == 3) {
          this.$router.push({path:'/make'});
          }
      }
    }
}
</script>
<style lang="scss" scoped>
  .service{
    height: 325px;
    background: $ffff;
    .title{
      height: 62px;
      font-size:30px;
      color:$color-51;
      line-height:70px;
      margin: 0 20px;
      padding-left: 16px;
      &::before{
        content: '';
        width:4px;
        height:20px;
        display: inline-block;
        margin-right: 17px;
        background:$color-176;
      }
    }
    .serviceUl{
        margin:  7px 33px 5px 33px;
        align-items: flex-end;
        .item{
            text-align: center;
            width: calc(100%/4);
            margin-top: 20px;
            p{
                margin-top: 15px;
                font-size:22px;
                color: $color-85;
            }
            img{
                width: 51px;
                height: auto;
            }
        }
    }
  }
</style>


